





















































import { Component, Model, Prop, Vue } from "vue-property-decorator";
import countryCodes from "@/assets/data/country-code.json";

@Component
class CountrySelet extends Vue {
  @Model("change") country!: string;

  @Prop() countries!: string[];

  dialog = false;

  search = "";

  get meta() {
    let countries = this.countries.map(x => {
      const country = countryCodes[x.toLowerCase()];
      return {
        id: x,
        name: country?.name ?? "",
        icon: `/country-flags/${x.toLowerCase()}.svg`
      };
    });
    if (this.search) {
      countries = countries.filter(x => {
        const search = this.search.toLowerCase();
        const name = x.name.toLowerCase();
        const id = x.id.toLowerCase();
        return name.startsWith(search) || id.startsWith(search);
      });
    }
    const selected = countries.find(x => x.id === this.country);
    return {
      selected,
      selectedIcon: selected?.icon,
      selectedName: selected?.name,
      countries
    };
  }

  handleSelect(id) {
    this.$emit("change", id);
    this.dialog = false;
  }
}
export default CountrySelet;
